import { jsx as u } from "react/jsx-runtime";
import p from "react";
import { c as d } from "./clsx.OuTLNxxd.js";
import { LOCATION_MODULE_LINK_REGEX as l } from "../constants/modules/index.js";
import { u as k } from "./header.context.gmG2mr37.js";
import { U as f } from "./unified-link.DNdCokeG.js";
const v = ({
  href: t,
  field: o
}) => {
  var i;
  if (t && t.startsWith("/locations/") && l.test(t)) return !0;
  const s = o && "value" in o ? o.value : o;
  return s && ((i = s.href) == null ? void 0 : i.startsWith("/locations/")) && l.test(s.href) || !1;
}, x = p.forwardRef(
  ({ href: t, field: o, className: r, children: s, prefetch: a, ...i }, e) => {
    const { isModule: m } = k(), L = v({ href: t, field: o });
    if (m || L) {
      const c = o && "value" in o ? o.value : o, { class: R, ...n } = c || {}, M = c ? { ...n, className: d(r, n.className) } : {
        href: t || "#",
        className: r,
        ...i
      };
      return /* @__PURE__ */ u("a", { ref: e, ...M, children: s || (n == null ? void 0 : n.text) });
    }
    return /* @__PURE__ */ u(
      f,
      {
        prefetch: a,
        ref: e,
        field: o,
        href: t || "",
        className: r,
        ...i,
        children: s
      }
    );
  }
);
x.displayName = "ModuleLink";
export {
  x as M,
  v as i
};
